/* src/modules/profile/cards/UserInfoCard/styles.js */

export default theme => ({
  height: theme.spacing.unit * 100,
  width: '100%',
  overflow: 'auto',
});



// WEBPACK FOOTER //
// ./src/modules/profile/cards/UserInfoCard/styles.js